module.exports = __webpack_public_path__ + "images/icons_v2/store-locator-baseline-outlined-bacab2ef.svg";